import { serialize } from "next-mdx-remote/serialize";

import { fetchChangelogEntries } from "lib/api";

import ChangelogEntry from "components/ChangelogEntry";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import SharedFooter from "components/SharedFooter";

import Container from "components/Container";

import styles from "styles/changelog.module.css";

import type { PropTypes as ChangelogEntryType } from "components/ChangelogEntry";

import type { Page } from "types/page";
import type { GetStaticProps, GetStaticPaths } from "next";

type PageProps = {
  changelogEntry: ChangelogEntryType;
};

type PageParams = {
  slug: string;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = (await fetchChangelogEntries()).map(({ slug }) => ({
    params: {
      slug,
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<PageProps, PageParams> = async (context) => {
  if (context.params === undefined) {
    return {
      notFound: true,
    };
  }

  const { slug } = context.params;
  const changelogEntries = await fetchChangelogEntries();
  const changelogEntry = changelogEntries.find((s) => s.slug === slug);
  if (changelogEntry !== undefined) {
    const mdxSource = changelogEntry.body ? await serialize(changelogEntry.body) : null;
    return {
      props: {
        changelogEntry: {
          ...changelogEntry,
          mdxSource,
        },
      },
    };
  }

  return {
    notFound: true,
  };
};

const SingleChangelog: Page<PageProps> = ({ changelogEntry }: PageProps) => {
  return (
    <div className={styles.changelogContainer}>
      <Container size="sm">
        <div className={styles.header}>
          <h1>Changelog</h1>
        </div>
        <ChangelogEntry {...changelogEntry} />
      </Container>
    </div>
  );
};

SingleChangelog.getLayout = (page) => {
  return (
    <ApplicationLayout>
      <Navbar />
      <PageContent>{page}</PageContent>
      <SharedFooter />
    </ApplicationLayout>
  );
};

export default SingleChangelog;
